export default [{
    path: '/returnProblem',
    component: () => import('@/views/returnProblem')
},

{
    path: '/returnProblem/:id',
    props: (route) => ({
        id:  Number(route.params.id)
    }),
    component: () => import('@/views/returnProblem/detail')
},
{
    path: '/returnProblem/:id/edit',
    props: (route) => ({
        id:  Number(route.params.id)
    }),
    component: () => import('@/views/returnProblem/edit')
},

]